import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

import ResumePdf from '../document/Resume.pdf';
import Cover from '../document/Cover-letter.pdf';

const Resume = () => {
  return (
    <section id="resume" className="pt-32 pb-32 mb-32">
      {/* HEADING */}
      <motion.div
        className="md:w-1/3 text-center md:text-left"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, x: -50 },
          visible: { opacity: 1, x: 0 },
        }}
      >
        <p className="font-playfair font-semibold text-4xl mb-5 text-green">
          CURRICULUM VITAE
        </p>
        <LineGradient width="w-4/5" />
        <p className="mt-10 text-lg">
          Here's some of my info, I havent updated my resume and personal letter to English. But soon...
        </p>
      </motion.div>

      {/* Resume */}
      <div className="md:flex md:justify-between gap-8 ">
        <motion.div
          className="mx-auto relative bg-pink max-w-[400px] h-[350px] flex flex-col justify-end p-16 mt-40 mb-40 
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <a onClick={() => window.open(ResumePdf)} className="font-playfair text-4xl cursor-pointer font-semibold underline">Resume</a>
          <p className="font-playfair text-2xl pt-4">
            Check out my Resume here
          </p>
        </motion.div>

        <motion.div
          className="mx-auto relative bg-red max-w-[400px] h-[350px] flex flex-col justify-end p-16 mt-40 mb-40
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <a onClick={() => window.open(Cover)} className="font-playfair text-4xl cursor-pointer font-semibold underline">Cover Letter</a>
          <p className="font-playfair text-2xl pt-4">
            Here's a letter about me and my dream
          </p>
        </motion.div>

        <motion.div
          className="mx-auto relative bg-yellow max-w-[400px] h-[350px] flex flex-col justify-end p-16 mt-40 mb-40
            before:absolute before:top-[-120px] before:-ml-[110px] before:left-1/2"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: { opacity: 1, scale: 1 },
          }}
        >
          <a target="_blank" href="https://github.com/Vitoleander" className="font-playfair text-4xl cursor-pointer font-semibold underline">Github repo</a>
          <p className="font-playfair text-2xl pt-4">
            Some of my projects, still updating..
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Resume;